import { render } from "./bmadd.vue?vue&type=template&id=6a39abcd&scoped=true"
import script from "./bmadd.vue?vue&type=script&lang=js"
export * from "./bmadd.vue?vue&type=script&lang=js"

import "./bmadd.vue?vue&type=style&index=0&id=6a39abcd&lang=scss&scoped=true"
import "./bmadd.vue?vue&type=style&index=1&id=6a39abcd&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a39abcd"]])

export default __exports__